import type { ButtonBarItem } from "@gearbox-protocol/deploy-tools-ui";
import {
  ButtonBar,
  ErrorBox,
  Spinner,
} from "@gearbox-protocol/deploy-tools-ui";
import {
  CreditSuiteSelector,
  CuratorSelector,
  MarketSelector,
  SDKView,
} from "components/sdk-state";
import { type FC, useState } from "react";
import type { SdkStateFilter, SdkStateLanguage } from "utils";
import type { Address } from "viem";

import { useSDK } from "../sdk-context";

const formatNav: ButtonBarItem<SdkStateLanguage>[] = [
  {
    id: "yaml",
    title: "YAML (state human)",
  },
  {
    id: "json",
    title: "JSON (raw state)",
  },
];

const emptyFilter: SdkStateFilter = {};

const SDKRoute: FC = () => {
  const { value: sdk, loading, error } = useSDK();
  const [language, setLanguage] = useState<SdkStateLanguage>("yaml");
  const [filter, setFilter] = useState<SdkStateFilter>(emptyFilter);

  const setCurator = (curator: Address | undefined) => {
    setFilter({ curator, market: undefined, creditManager: undefined });
  };
  const setMarket = (market: Address | undefined) => {
    setFilter(current => ({
      curator: current.curator,
      market,
      creditManager: undefined,
    }));
  };
  const setCreditManager = (creditManager: Address | undefined) => {
    setFilter(current => ({ ...current, creditManager }));
  };

  return (
    <div className="flex flex-row items-start gap-x-4">
      <div className="w-96 flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4 min-h-96">
        <ButtonBar<SdkStateLanguage>
          items={formatNav}
          activeId={language}
          onChange={setLanguage}
          buttonClassName="py-1! bg-white/10 hover:bg-black/10 has-checked:bg-black/20"
        />
        {!!sdk && (
          <>
            <CuratorSelector
              sdk={sdk}
              value={filter.curator}
              onChange={setCurator}
            />
            <MarketSelector
              sdk={sdk}
              curator={filter.curator}
              value={filter.market}
              onChange={setMarket}
            />
            <CreditSuiteSelector
              sdk={sdk}
              market={filter.market}
              value={filter.creditManager}
              onChange={setCreditManager}
            />
          </>
        )}
      </div>
      <div className="flex-1 flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4 min-h-full overflow-x-hidden">
        {!!loading && (
          <div className="flex-1 flex items-center justify-center">
            <Spinner />
          </div>
        )}
        {!!error && (
          <div className="flex-1">
            <ErrorBox error={error} />
          </div>
        )}
        <SDKView
          sdk={sdk}
          language={language}
          curator={filter.curator}
          market={filter.market}
          creditManager={filter.creditManager}
        />
      </div>
    </div>
  );
};

export default SDKRoute;
